import React from "react";
import {Button} from "@vkontakte/vkui";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {
    BUY_COINS_MODAL,
    GAME_FAILED_FINISH_MODAL,
    GAME_RESULTS_MODAL,
    GAME_SUCCESS_FINISH_MODAL,
    SUBSCRIBE_MISSIONS_MODAL,
    SUBSCRIBE_TOURNAMENT_MODAL,
    TOURNAMENT_GOOD_LUCK_MODAL
} from "../../routing/routing";

const MODAL_TEST_FLAG_KEY = "wordmania_modal_test_enabled";

// Показывает тестовые кнопки для открытия модальных окон
export default function ModalTestPanel() {
    const routeNavigator = useRouteNavigator();

    let isEnabled = false;
    try {
        isEnabled = localStorage.getItem(MODAL_TEST_FLAG_KEY) === "1";
    } catch (error) {
        isEnabled = false;
    }

    if (!isEnabled) {
        return null;
    }

    const modalEntries = [
        {id: GAME_RESULTS_MODAL, label: "Итоги игры"},
        {id: GAME_SUCCESS_FINISH_MODAL, label: "Победа"},
        {id: GAME_FAILED_FINISH_MODAL, label: "Поражение"},
        {id: SUBSCRIBE_TOURNAMENT_MODAL, label: "Подписка на турнир"},
        {id: SUBSCRIBE_MISSIONS_MODAL, label: "Подписка на миссии"},
        {id: TOURNAMENT_GOOD_LUCK_MODAL, label: "Удачи в турнире"},
        {id: BUY_COINS_MODAL, label: "Покупка монет"},
    ];

    return (
        <div className="w-full bg-gray-200 text-gray-800 rounded-xl p-4 border border-gray-300/50 shadow-sm">
            <div className="text-sm font-semibold text-gray-800 mb-3">Тест модальных окон</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {modalEntries.map((modal) => (
                    <Button
                        key={modal.id}
                        size="s"
                        mode="secondary"
                        className="app-btn-secondary"
                        onClick={() => routeNavigator.showModal(modal.id)}
                    >
                        {modal.label}
                    </Button>
                ))}
            </div>
        </div>
    );
}
